// extracted by mini-css-extract-plugin
module.exports = {"list":"dnU7D","selected":"_1K48f"};